import { useStateAsStream } from 'annotation-tools/utils';
import { useState } from 'react';
import { Observable } from 'rxjs';
import { FetchErrorType } from '../../api/types/common/fetch-error-type';
import { FetchResultType } from '../../api/types/common/fetch-result';
import { IAPIValidationErrorType } from '../../api/types/common/validation-error';

type ResultType<SuccessResponseBodyType, APIRequestBodyType> = FetchResultType<
  SuccessResponseBodyType,
  FetchErrorType<IAPIValidationErrorType<APIRequestBodyType>>
>;

export const useFetchResultState = <
  SuccessResponseBodyType,
  APIRequestBodyType
>(): [
  undefined | ResultType<SuccessResponseBodyType, APIRequestBodyType>,
  (v: ResultType<SuccessResponseBodyType, APIRequestBodyType>) => void
] => {
  const [fetchResult, setResult] = useState<
    undefined | ResultType<SuccessResponseBodyType, APIRequestBodyType>
  >(undefined);

  return [fetchResult, setResult];
};

export const useFetchResultStateAsStream = <
  SuccessResponseBodyType,
  APIRequestBodyType
>(): [
  Observable<
    undefined | ResultType<SuccessResponseBodyType, APIRequestBodyType>
  >,
  (v: ResultType<SuccessResponseBodyType, APIRequestBodyType>) => void
] => {
  const [fetchResult$, setFetchResult] = useStateAsStream<
    | undefined
    | FetchResultType<
        SuccessResponseBodyType,
        FetchErrorType<IAPIValidationErrorType<APIRequestBodyType>>
      >
  >(undefined);

  return [fetchResult$, setFetchResult];
};
